import { render, staticRenderFns } from "./WorkflowStepResolutionPage.vue?vue&type=template&id=7c1e6665&scoped=true&"
import script from "./WorkflowStepResolutionPage.vue?vue&type=script&lang=js&"
export * from "./WorkflowStepResolutionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1e6665",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
